/** @file GENERATED by pnpm gen; do not edit. */
import { panel as e0 } from './panels/activity/Panel';
import { panel as e1 } from './panels/aiView/Panel';
import { panel as e2 } from './panels/animations/Panel';
import { panel as e3 } from './panels/assets/Panel';
import { panel as e4 } from './panels/autorig/Panel';
import { panel as e5 } from './panels/constraints/Panel';
import { panel as e6 } from './panels/directions/Panel';
import { panel as e7 } from './panels/drawOrder/Panel';
import { panel as e8 } from './panels/events/Panel';
import { panel as e9 } from './panels/hierarchy/Panel';
import { panel as e10 } from './panels/inspector/Panel';
import { panel as e11 } from './panels/skins/Panel';
import { panel as e12 } from './panels/sockets/Panel';
import { panel as e13 } from './panels/timeline/Panel';
import { panel as e14 } from './panels/viewport/Panel';
import { panel as e15 } from './panels/weights/Panel';
export const PANELS = [e0, e1, e2, e3, e4, e5, e6, e7, e8, e9, e10, e11, e12, e13, e14, e15] as const;
